import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';

import { mlpTypes } from '../../../common/constants';
import { FormInputSelect } from '../../../common/formInputsV2/FormInputSelect';
import {
  SurfaceCard, SurfaceCardHeader, SurfaceCardHeading, SurfaceCardCloseButton,
} from '../../../common/formInputsV2/Card.styles';
import managementServisAxeClientBackoffice from '../../../services/axios-client/managementServisAxeClientBackoffice';

function MLPActivitiesBackoffice({
  index, remove, errors, isValid, formDataFlow, control, setValue,
}) {
  const [activities, setActivities] = useState([]);

  const getActivities = async () => {
    const response = await managementServisAxeClientBackoffice.get(`/health-professions/medici-liberi-professionista/${formDataFlow.activities[index]?.activity_type}/${formDataFlow.massimale}/${formDataFlow.retroactivity}`);
    if (response.status !== 200) {
      setActivities([]);
      return;
    }
    setActivities(response.data.activities);
  };

  useEffect(() => {
    if (formDataFlow.activities[index]?.activity_type) {
      getActivities();
    }
  }, [index, formDataFlow.activities[index]?.activity_type]);

  return (
    <SurfaceCard>
      <SurfaceCardHeader>
        <SurfaceCardHeading>Aggiungi Tipologia e attivita svolta</SurfaceCardHeading>
        {index !== 0 && (
          <SurfaceCardCloseButton type="button" aria-label="Rimuovi" onClick={() => remove(index)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </SurfaceCardCloseButton>
        )}
      </SurfaceCardHeader>
      <Controller
        name={`activities.${index}.activity_type`}
        control={control}
        render={({ field }) => (
          <FormInputSelect
            label="Tipologia di attività"
            value={field.value}
            onChange={(value) => setValue(`activities.${index}.activity_type`, value, {
              shouldValidate: true,
              shouldDirty: true,
              shouldTouch: true,
            })}
            error={errors.activities?.[index]?.activity_type?.message}
            valid={isValid(`activities.${index}.activity_type`)}
            placeholder="-Seleziona-"
            options={mlpTypes}
          />
        )}
      />

      <Controller
        name={`activities.${index}.activity`}
        control={control}
        render={({ field }) => (
          <FormInputSelect
            label="Attività Svolta"
            value={field.value}
            onChange={(value) => setValue(`activities.${index}.activity`, value, {
              shouldValidate: true,
              shouldDirty: true,
              shouldTouch: true,
            })}
            error={errors.activities?.[index]?.activity?.message}
            valid={isValid(`activities.${index}.activity`)}
            placeholder="-Seleziona-"
            options={activities}
          />
        )}
      />
    </SurfaceCard>
  );
}

export default MLPActivitiesBackoffice;
